module.exports = __webpack_public_path__ + "img/65.d87f0948.jpg";